<template>
  <div class="modal-backdrop" v-if="isVisible" @click.self="cancel">
    <div class="modal-container">
      <div class="modal-title-container">
          <div class="modal-divider"></div>
        </div>
      <div class="icon-container">
        <span class="material-symbols-outlined warning-icon">warning</span>
      </div>
      <h2>{{ title }}</h2>
      <p v-html="message"></p>
      <div class="button-container">
        <button class="confirm-button" @click="confirm">{{ confirmButtonLabel }}</button>
        <button class="cancel-button" @click="cancel">{{ cancelButtonLabel }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AreYouSureModal',
  props: {
    isVisible: Boolean,
    title: String,
    message: String,
    confirmButtonLabel: {
      type: String,
      default: 'OK',
    },
    cancelButtonLabel: {
      type: String,
      default: 'Cancel',
    },
    itemId: { 
      type: [String, Number],
      required: false,
    },  
  },
  methods: {
    confirm() {
      this.$emit('result', true, this.itemId);
    },
    cancel() {
      this.$emit('result', false, this.itemId);
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal-container {
  background-color: white;
  border-radius: 12px;
  padding: 5px 20px 20px; 
  width:  90%;
  max-width: 500px;
  text-align: center;
  position: relative;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
}

.icon-container {
  margin: 20px 0;
}

.warning-icon {
  background: #ff4d4f3b;
  font-size: 35px;
  color: #ff4d4f;
  padding: 8px;
  border-radius: 8px;
}

h2 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}

p {
  font-size: 14px;
  color: #666;
}

.modal-title-container {
  display: flex;
  justify-content: center;
}

.modal-divider {
    width: 70px;
    height: 4px;
    background: #ccc;
    border-radius: 2px;
    margin-top: 8px;
    cursor: pointer;
    display: none; 
}

.button-container {
  display: flex;
  margin-top: 20px;
  flex-wrap: wrap;
}

.confirm-button {
  width: 100%;
  background-color: #ff4d4f;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
}

.cancel-button {
  width: 100%;
  margin-top: 10px;
  background-color: white;
  color: #666;
  border: 1px solid #ddd;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
}

/* Mobile responsiveness */
@media screen and (max-width: 768px) {
  .modal-backdrop{
    margin: 0;
  }

  .modal-container {
    width: 100%;
    max-width: 100%;
    border-radius: 20px 20px 0 0;
    position: absolute;
    bottom: 0;
    animation: slideUp 0.3s ease-out;
  }

  .modal-title-container{
    margin-bottom: 5px;
  }
  
  .modal-divider {
    display: block; /* Show the divider on mobile */
  }

  .button-container {
    flex-direction: column;
    align-items: center;
  }

  .confirm-button,
  .cancel-button {
    width: 100%; /* Full width on mobile */
  }

  .cancel-button {
    margin-top: 10px;
  }
  
  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
}
</style>